import { render, staticRenderFns } from "./tcvideo.vue?vue&type=template&id=2ce024d8&scoped=true"
import script from "./tcvideo.vue?vue&type=script&lang=js"
export * from "./tcvideo.vue?vue&type=script&lang=js"
import style0 from "./tcvideo.vue?vue&type=style&index=0&id=2ce024d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce024d8",
  null
  
)

export default component.exports